<template>
  <div
    v-loading="isPlayLoading"
    element-loading-background="#000000"
    element-loading-text="请稍等, 视频加载中......"
    element-loading-customClass="loadingClass"
    ref="container"
    @dblclick="fullscreenSwich"
    style="width: 100%; height: 100%; background-color: #000000; margin: 0 auto"
  >
    <div class="buttons-box" id="buttonsBox">
      <div class="controlBtn">
        <div v-if="!isLive" class="buttons-box-left">
          <span style="margin-right: 12px">时间定位</span>
          <el-time-picker
            v-model="queryData.beginTime"
            :picker-options="{
              selectableRange: cutTime(beginTime, ' ', 1) + '-' + cutTime(endTime, ' ', 1),
            }"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="HH:mm:ss"
            placeholder="选择开始时间"
          />
          <span style="margin: 0 12px">至</span>
          <el-time-picker
            v-model="queryData.endTime"
            :disabled="!queryData.beginTime"
            :picker-options="{
              selectableRange: cutTime(queryData.beginTime, ' ', 1) + '-' + cutTime(endTime, ' ', 1),
            }"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="HH:mm:ss"
            placeholder="选择结束时间"
          />
          <div @click="fixedPointPlay" style="margin: 0 12px">定位</div>
          <div @click="reset">重置</div>
        </div>
        <div class="buttons-box-right">
          <span class="jessibuca-btn">{{ kBps }} kb/s</span>
          <i v-if="!playing" class="iconfont icon-play jessibuca-btn" @click="playBtnClick"></i>
          <i v-if="playing" class="iconfont icon-pause jessibuca-btn" @click="pause"></i>
          <!-- <i class="iconfont icon-stop jessibuca-btn" @click="destroy"></i> -->
          <i v-if="isNotMute" class="iconfont icon-audio-high jessibuca-btn" @click="mute()"></i>
          <i v-if="!isNotMute" class="iconfont icon-audio-mute jessibuca-btn" @click="cancelMute()"></i>
          <el-tooltip effect="light" content="截屏" placement="top-start">
            <i class="iconfont icon-camera1196054easyiconnet jessibuca-btn" @click="screenshot" style="font-size: 16px !important"></i>
          </el-tooltip>
          <!-- <el-tooltip effect="light" content="刷新" placement="top-start">
            <i class="iconfont icon-shuaxin11 jessibuca-btn" @click="playBtnClick"></i>
          </el-tooltip> -->
          <el-tooltip effect="light" content="全屏" placement="top-start">
            <i v-if="!fullscreen" class="iconfont icon-weibiaoti10 jessibuca-btn" @click="fullscreenSwich"></i>
          </el-tooltip>
          <el-tooltip effect="light" content="取消全屏" placement="top-start">
            <i v-if="fullscreen" class="iconfont icon-weibiaoti11 jessibuca-btn" @click="fullscreenSwich"></i>
          </el-tooltip>
        </div>
      </div>
      <div v-if="!isLive" class="progressBar">
        <div class="time">{{ beginTime.split(' ')[1] }}</div>
        <el-slider id="playtimeSlider" v-model="playTime" :min="sliderMIn" :max="sliderMax" :format-tooltip="playTimeFormat" @change="sliderChange" class="slider"></el-slider>
        <div class="time">{{ endTime.split(' ')[1] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

let jessibucaPlayer = {}
export default {
  name: 'jessibuca',
  props: {
    videoUrl: {
      type: Object,
      default: () => {},
    },
    beginTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    isLive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      playing: false,
      isNotMute: false,
      fullscreen: false,
      speed: 0,
      performance: '', // 工作情况
      kBps: 0,
      btnDom: null,
      videoInfo: null,
      volume: 1,
      rotate: 0,
      vod: true, // 点播
      forceNoOffscreen: false,
      playTime: 0, // 需要定位到的播放时间点
      queryData: {
        beginTime: '',
        endTime: '',
      },
      sliderMIn: 0,
      isPlayLoading: false, // 播放加载
      isError: false, // 是否报错
      isPoint: false, // 是否是选择时间范围定点播放
    }
  },
  computed: {
    sliderMax: {
      get() {
        return (new Date(this.endTime).getTime() - new Date(this.beginTime).getTime()) / 1000
      },
      set(value) {
        return value
      },
    },
  },

  mounted() {
    this.$watch(
      'videoUrl',
      () => {
        if (this.videoUrl) {
          this.play(this.videoUrl.localUrl, false)
        } else {
          this.stop()
        }
      },
      { immediate: true, deep: true }
    )
    // this.setTime(this.beginTime)
    let paramUrl = decodeURIComponent(this.$route.params.url)
    this.$nextTick(() => {
      // this.updatePlayerDomSize()
      window.onresize = () => {
        // this.updatePlayerDomSize()
      }
      this.btnDom = document.getElementById('buttonsBox')

      if (paramUrl && paramUrl !== 'undefined') this.play(paramUrl, false)
    })
  },
  methods: {
    updatePlayerDomSize() {
      let dom = this.$refs.container
      let width = dom.parentNode.clientWidth
      let height = (9 / 16) * width

      const clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
      if (height > clientHeight) {
        height = clientHeight
        width = (16 / 9) * height
      }

      dom.style.width = width + 'px'
      dom.style.height = height + 'px'
    },
    create() {
      let options = {}

      jessibucaPlayer[this._uid] = new window.Jessibuca(
        Object.assign(
          {
            container: this.$refs.container,
            autoWasm: true,
            background: '',
            controlAutoHide: false,
            debug: false,
            decoder: '/jessibuca/decoder.js',
            forceNoOffscreen: true,
            hasAudio: true, // 控制是否解析音频
            hasVideo: true,
            heartTimeout: 5,
            heartTimeoutReplay: true,
            heartTimeoutReplayTimes: 3,
            hiddenAutoPause: false,
            hotKey: false,
            isFlv: false,
            // isFullResize: false,
            isNotMute: this.isNotMute,
            // isResize: false,
            keepScreenOn: false,
            // loadingText: '请稍等, 视频加载中......',
            loadingTimeout: 10,
            loadingTimeoutReplay: true,
            loadingTimeoutReplayTimes: 3,
            openWebglAlignment: false,
            operateBtns: {
              fullscreen: false,
              screenshot: false,
              play: false,
              audio: false,
              record: false,
            },
            recordType: 'webm',
            rotate: 0,
            showBandwidth: false,
            supportDblclickFullscreen: false,
            timeout: 10,
            useMSE: location.hostname !== 'localhost' && location.protocol !== 'https:',
            useOffscreen: false,
            useWCS: location.hostname === 'localhost' || location.protocol === 'https',
            useWebFullScreen: false,
            videoBuffer: 1,
            wasmDecodeAudioSyncVideo: true,
            wasmDecodeErrorReplay: true,
            wcsUseVideoRender: true,
          },
          options
        )
      )
      let jessibuca = jessibucaPlayer[this._uid]
      let _this = this
      jessibuca.on('load', function () {
        _this.$emit('success')
      })

      jessibuca.on('log', function (msg) {})
      jessibuca.on('record', function (msg) {})
      jessibuca.on('pause', function () {
        _this.playing = false
      })
      jessibuca.on('play', function () {
        _this.playing = true
      })
      jessibuca.on('fullscreen', function (msg) {
        _this.fullscreen = msg
      })

      jessibuca.on('mute', function (msg) {
        _this.isNotMute = !msg
      })
      jessibuca.on('audioInfo', function (msg) {})

      jessibuca.on('bps', function (bps) {
        //
      })
      jessibuca.on('timeUpdate', function (ts) {
        if (!_this.isLive) {
          // let timeStr = dayjs(new Date(_this.beginTime).getTime() + ts).format('YYYY-MM-DD HH:mm:ss')
          // _this.setTime(timeStr)
        }
      })

      jessibuca.on('videoInfo', function (info) {})

      jessibuca.on('error', function (error) {
        if (_this.isError) return
        _this.play(_this.videoUrl.publicUrl, true)
      })

      jessibuca.on('timeout', function () {})

      jessibuca.on('start', function () {
        _this.isNotMute = false
      })

      jessibuca.on('performance', function (performance) {
        let show = '卡顿'
        if (performance === 2) {
          show = '非常流畅'
        } else if (performance === 1) {
          show = '流畅'
        }
        _this.performance = show
      })
      jessibuca.on('buffer', function (buffer) {
        //
      })

      jessibuca.on('stats', function (stats) {
        //
      })

      jessibuca.on('kBps', function (kBps) {
        _this.kBps = Math.round(kBps)
      })

      // 显示时间戳 PTS
      jessibuca.on('videoFrame', function () {})

      //
      jessibuca.on('metadata', function () {})
    },
    playBtnClick(event) {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].play()
        return
      }
      this.play(this.videoUrl.publicUrl)
    },
    play(url, state) {
      this.isError = state
      this.isPlayLoading = true
      if (jessibucaPlayer[this._uid]) return
      this.create()
      jessibucaPlayer[this._uid].on('play', () => {
        this.isPlayLoading = false
        this.playing = true
        this.loaded = true
      })
      if (jessibucaPlayer[this._uid].hasLoaded()) {
        jessibucaPlayer[this._uid].play(url)
      } else {
        jessibucaPlayer[this._uid].on('load', () => {
          jessibucaPlayer[this._uid].play(url)
        })
      }
    },
    pause() {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].pause()
      }
      this.playing = false
      this.err = ''
      this.performance = ''
    },
    screenshot() {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].screenshot()
      }
    },
    mute() {
      if (jessibucaPlayer[this._uid]) {
        this.isNotMute = false
        jessibucaPlayer[this._uid].mute()
      }
    },
    cancelMute() {
      if (jessibucaPlayer[this._uid]) {
        this.isNotMute = true
        jessibucaPlayer[this._uid].cancelMute()
      }
    },
    destroy() {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].destroy()
      }
      if (document.getElementById('buttonsBox') == null) {
        this.$refs.container.appendChild(this.btnDom)
      }
      jessibucaPlayer[this._uid] = null
      this.playing = false
      this.err = ''
      this.performance = ''
      this.isPoint = false
    },
    fullscreenSwich() {
      let isFull = this.isFullscreen()
      jessibucaPlayer[this._uid].setFullscreen(!isFull)
      this.fullscreen = !isFull
    },
    isFullscreen() {
      return document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || false
    },

    /**
     * 关于滑块的一些处理
     */
    setTime(time) {
      this.playTime = (new Date(time).getTime() - new Date(this.beginTime).getTime()) / 1000
    },

    // 处理滑块tooltip格式
    playTimeFormat(val) {
      return dayjs(new Date(this.beginTime).getTime() + val * 1000).format('HH:mm:ss')
    },

    // 滑块改变后的值
    sliderChange(e) {
      const start = this.isPoint ? this.queryData.beginTime : this.beginTime
      const end = this.isPoint ? this.queryData.endTime : this.endTime
      let startTimeStr = dayjs(new Date(start).getTime() + e * 1000).format('YYYY-MM-DD HH:mm:ss')
      setTimeout(() => {
        this.$emit('sliderChange', {
          beginTime: startTimeStr,
          endTime: end,
          type: 1,
        })
      }, 500)
    },

    // 定位播放
    fixedPointPlay() {
      this.isPoint = true
      this.sliderMax = (new Date(this.queryData.endTime).getTime() - new Date(this.queryData.beginTime).getTime()) / 1000
      this.playTime = 0
      this.$emit('sliderChange', {
        ...this.queryData,
        type: 2,
      })
    },

    // 重置
    reset() {
      this.$emit('sliderChange', {
        type: 3,
      })
    },
  },
  destroyed() {
    if (jessibucaPlayer[this._uid]) {
      jessibucaPlayer[this._uid].destroy()
    }
    this.playing = false
    this.performance = ''
  },
}
</script>

<style lang="scss" scoped>
.buttons-box {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: rgba(43, 51, 63, 0.7);
  position: absolute;
  left: 0;
  bottom: 0;
  user-select: none;
  z-index: 10;
  .controlBtn {
    display: flex;
    align-items: center;
    min-height: 28px;
  }
  .progressBar {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .slider {
      flex: 1;
      margin: 0 8px;
    }
    .time {
      font-size: 14px;
      color: #ffffff;
    }
  }
}

.jessibuca-btn {
  width: 20px;
  color: rgb(255, 255, 255);
  line-height: 27px;
  margin: 0px 10px;
  padding: 0px 2px;
  cursor: pointer;
  text-align: center;
  font-size: 13px !important;
}

.buttons-box-right {
  position: absolute;
  right: 0;
}
.buttons-box-left {
  display: flex;
  color: #ffffff;
  font-size: 14px;
  align-items: center;
}
</style>
